<template>
  <v-row class="body">
    <v-col
      class="pa-13"
      align="center"
      cols="12"
      md="5"
      xl="3"
      lg="4"
      sm="12"
      xs="12"
    >
      <v-form @submit.prevent="login" ref="form">
        <div v-if="redirecturl && appId">
          <v-card class="card mt-8 pa-6">
            <img
              style="width: 6rem"
              class="mb-3"
              :src="require('../../public/logo.png')"
              alt=""
            />
            <v-card-title class="Login-title pa-0 ma-0 mb-5" align="center"
              >Login</v-card-title
            >
            <v-error class="error" v-if="error"
              >Invalid Username And Password</v-error
            >

            <v-col class="pa-0 pt-2 mt-2">
              <v-col align="start" class="pa-0 ma-0 lable">Email</v-col>
              <TextFieldComponent
                density="compact"
                placeholder="Your Email"
                type="email"
                append-inner-icon="mdi-email-outline"
                :rules="[rules.userRule, rules.emailValidation]"
                v-model="email"
                variant="outlined"
              >
              </TextFieldComponent>
            </v-col>
            <v-col class="pa-0 pt-2">
              <v-col align="start" class="pa-0 ma-0 lable">Password</v-col>
              <TextFieldComponent
                density="compact"
                @click:append-inner="showPassword = !showPassword"
                placeholder="Password"
                :rules="passwordRule"
                v-model="password"
                variant="outline"
                v-bind:type="[showPassword ? 'text' : 'password']"
                :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              >
              </TextFieldComponent>
            </v-col>
            <v-col class="pa-0" cols="12" align="center">
              <p style="color: red">{{ message }}</p>
            </v-col>
            <v-col cols="12" align="start" class="pa-0 ma-0 mt-2">
              <v-btn
                variant="text"
                class="forget pa-0 ma-0 mb-3"
                to="/forgetpassword"
                >Forget Password ?</v-btn
              >
            </v-col>

            <v-col class="pa-0 pt-2" cols="12" align="center">
              <v-btn
                block
                color="#0068B3"
                type="submit"
                size="large"
                :disabled="loading"
                :loading="loading"
                class="text-none mb-4 text-white log-btn"
              >
                Login</v-btn
              >
            </v-col>
          </v-card>
          <v-col class="mt-4 log-text"
            >If you have trouble signinin in please contact administrator</v-col
          >
        </div>
        <v-card v-else>
          &nbsp;
          <v-img style="margin: 0 auto" width="100px"></v-img>
          <v-card-text class="text-red" style="font-weight: 700"
            >Request did not originate from an Authorized domain!</v-card-text
          >
        </v-card>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
// import UserService from "@/api/service/UserService";
import TextFieldComponent from "./TextFieldComponent.vue";
import userService from "../api/service/UserService.js";
//import config from "../api/config/config.js";
import { authStore } from "@/store";

import DynamodbModel from "@/api/service/Dynamodb/DynamodbService";

export default {
  components: {
    TextFieldComponent,
  },
  data() {
    return {
      loading: false,
      error: false,
      host: window.location.host,
      message: null,
      redirecturl: null,
      showPassword: false,
      password: "",
      emailValidation: "",
      passwordRule: [(value) => !!value || "Password is Required."],
      email: "",
      rules: {
        userRule: (value) => !!value || "Email is Required.",
      },
    };
  },
  created() {
    if (this.$route.query.appId) {
      let data = {
        appId: this.$route.query.appId,
        sessionId: this.$route.query.sessionId,
        redirectUrl: this.$route.query.redirectUrl,
      };

      localStorage.setItem("APP_ID", this.$route.query.appId);
      localStorage.setItem("login_details", JSON.stringify(data));
    }
    let $data = JSON.parse(localStorage.getItem("login_details"));
    console.log($data, "datatata");

    this.redirecturl = $data.redirectUrl;
    localStorage.setItem("REDIRECT_URL", this.redirecturl);
    this.appId = $data.appId;

    this.getAppDetail();
  },
  computed: {
    appDetail() {
      return authStore.getters.getAppDetail;
    },
  },

  methods: {
    async getAppDetail() {
      if (this.$route.query.appId) {
        let res = await DynamodbModel.AppDetails(this.$route.query.appId);
        console.log(res, "hlo");
        authStore.commit("setAppDetail", res);
        this.loading = false;
      } else {
        this.loading = false;
      }
    },
    async login() {
      if (this.email && this.password) {
        this.loading = true;
        try {
          let response = await userService.fireBaseLogin({
            email: this.email,
            password: this.password,
            appId: this.$route.query.appId,
          });
          if (response.meta.message) {
            (this.loading = false), (this.error = true);
          }
          if (response.data.token) {
            try {
              this.$router.push({
                path: "/verify",
                query: { email: this.email, token: response.data.token },
              });
              // window.location = this.redirecturl + "?token=" + response.token;
            } catch (e) {
              this.error = true;
              this.loading = false;
              console.log(e);
            }
          }
        } catch (e) {
          this.error = true;
          this.loading = false;
        }
      }
      // else {
      //    if(response.data){
      //   this.error = true
      //    }
      // }
    },
  },
};
</script>
<style>
.body {
  background-color: #0068b3;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
}
.Login-title {
  font-size: 16px;
  font-weight: 600;
}
.forget {
  cursor: pointer;
  font-weight: 500;
  color: black;
  font-size: 12px;
}
.lable {
  font-size: 12px;
  margin-bottom: 6px !important;
  font-weight: 600;
}
.forget:hover {
  color: rgb(104, 104, 246);
  cursor: pointer;
}
.log-text {
  font-size: 14px;
  color: #fff;
  font-weight: 400;
  width: 300px;
}
.log-btn {
  font-size: 14px;
  font-weight: 400;
}
.error {
  margin-top: 14px !important;
  color: rgb(255, 0, 0);
  font-size: 15px;
}
</style>
